import React from 'react'
import PoleLocalisationView from './PoleLocalisationView/PoleLocalisationView'
import { useSinglePole } from '../../../../hooks'

export default function PoleLocalisationPresenter() {
    const {singlePoleQuery:{data}} = useSinglePole()
  return (
    <PoleLocalisationView lat={data?.pole_location_lat} lng={data?.pole_location_lng}/>
  )
}
